// src/shared/utils/formatters.js
export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};

export const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const penaltyDaysLate = (penaltyFactor) => {
    if (penaltyFactor === undefined || penaltyFactor === null || penaltyFactor >= 1.0) return null;
    if (penaltyFactor <= 0.0) return '5+ days late';
    const brackets = Math.round((1.0 - penaltyFactor) / 0.2);
    return `${brackets} day${brackets !== 1 ? 's' : ''} late`;
};

export const calculatePace = (duration, distance, activityType) => {
    if (!duration || !distance) return '0:00';

    const paceInSeconds = duration / distance;
    const minutes = Math.floor(paceInSeconds / 60);
    const seconds = Math.floor(paceInSeconds % 60);

    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};